import React, { useEffect, useMemo, useRef, useState } from 'react'
import styled from 'styled-components';
import { useTranslate } from '@tolgee/react';
import { FixedSizeList as List } from "react-window"; // Import react-window
import ContactElement from './ContactElement';
import SearchMenu from '../GenericComponents/SearchMenu';
import { CONTACTS, INVITE } from '../../Constants/constantValues';
import EmptyContactsList from './EmptyContactsList';

const ContactsList = ({ contacts, inviteAction, callAction, chatAction, containerClickAction }) => {



    const [searchValue, setSearchValue] = useState("");
    const [toggle, setToggle] = useState(CONTACTS);
    const [listHeight, setListHeight] = useState(0);
    const containerRef = useRef(null);

    const searchContact = (list) => {
        const searchTerm = searchValue?.toLowerCase() || "";

        if (searchTerm === "") {
            return list;
        }

        return list.filter((item) => {
            const name = item?.name?.toLowerCase();
            return name?.startsWith(searchTerm);
        });
    };
    const filteredContacts = useMemo(() => {
        return contacts?.outside_contacts ? searchContact(contacts.outside_contacts) : [];
    }, [contacts?.outside_contacts, searchValue]);



    useEffect(() => {
        const updateHeight = () => {
            if (containerRef.current) {
                setListHeight(containerRef.current.clientHeight);
            }
        };

        updateHeight(); // Set height on mount
        window.addEventListener("resize", updateHeight); // Update on resize
        return () => window.removeEventListener("resize", updateHeight);
    }, [toggle]);
    const { t } = useTranslate();
    return (
        <ContactsListWrapper>
            <div style={{ padding: "16px 16px 0 16px" }}>
                <SearchMenu
                    value={searchValue}
                    setvalue={setSearchValue}

                />
            </div>
            <div style={{ padding: "0 16px" }}>
                <ToggleContainer>
                    <ToggleButton
                        selected={toggle === CONTACTS}
                        onClick={(e) => setToggle(CONTACTS)}
                    >
                        {t('general.contacts')}
                    </ToggleButton>
                    <ToggleButton
                        selected={toggle === INVITE}
                        onClick={(e) => setToggle(INVITE)}
                    >
                        {t('new_chat.invite_to_emotii')}
                    </ToggleButton>
                </ToggleContainer>
            </div>
            {toggle === CONTACTS &&
                <>
                    {contacts &&
                        contacts.on_app_contacts?.length > 0 &&
                        <OptionsWrapper >
                            <ContactListWrapper>
                                {
                                    searchContact(contacts.on_app_contacts).map((contact) => (
                                        <ContactElement
                                            key={contact.id}
                                            item={contact}
                                            callAction={callAction}
                                            chatAction={chatAction}
                                            containerClickAction={containerClickAction}
                                        />
                                    ))}
                            </ContactListWrapper>
                        </OptionsWrapper>
                    }

                    { contacts &&
                        contacts.on_app_contacts?.length === 0 &&
                        <EmptyContactsList />
                    }
                </>
            }

            {toggle === INVITE &&
                <>
                    {contacts &&
                        contacts.outside_contacts?.length > 0 &&
                        <OptionsWrapper ref={containerRef}>
                            {listHeight > 0 && (
                                <List
                                    height={listHeight}// Adjust this based on the height of the container
                                    itemCount={filteredContacts.length}
                                    itemSize={68} // Adjust based on the size of each contact element
                                    width="100%" // Full width of the container
                                >
                                    {({ index, style }) => {
                                        const contact = filteredContacts[index];
                                        return (
                                            <ContactElement
                                                style={style}
                                                key={contact.id}
                                                item={contact}
                                                handleInvite={inviteAction}
                                            />)
                                    }}
                                </List>)}
                        </OptionsWrapper>
                    }
                    
                    { contacts &&
                        contacts.outside_contacts?.length === 0 &&
                        <EmptyContactsList />
                    }
                </>}

        </ContactsListWrapper>
    )
}

export default ContactsList
const ContactsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  width: 100%;
  gap:20px;
`;


const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1; /* This ensures it takes all available height */
  gap: 10px;
  overflow: hidden; /* Prevents unwanted scrolling */
`;
const ContactListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height:100%;
overflow:auto;
`;

const ToggleContainer = styled.div`
display:flex;
align-items:center;
border-radius:4px;
overflow:hidden;
background:${({ theme }) => theme.menu.background};
border:1px solid ${({ theme }) => theme.toggleButton.borderColor};
`;
const ToggleButton = styled.button`
display:flex;
align-items:center;
gap:10px;
border:none;
background:${({ theme, selected }) => selected ? theme.menu.enterPhoneNumberBackground : "none"};
font-weight:${({ selected }) => selected ? 600 : 500};
font-size: 16px;
line-height: 18px;
color:${({ theme, selected }) => selected ? theme.primaryButton.color : theme.menu.toggleFadedColor};

padding:8px 12px;
width:100%;
justify-content:center;
min-width:120px;
cursor:pointer;
svg{
height:20px;
}
`